var map = {
	"./amazon.gif": "90c8",
	"./assassin.gif": "6c54",
	"./barbarian.gif": "f408",
	"./druid.gif": "e910",
	"./necromancer.gif": "bead",
	"./overfloadig.gif": "70c1",
	"./paladin.gif": "9711",
	"./sorceress.gif": "b407"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "455a";